// @flow
import { handleResponseOld, makeGet } from './helpers';

type FetchLotsBySellerIdParams = {
    authToken: string,
    deployment: string,
    sellerId: number,
};

export default {
    fetchLotsBySellerId: ({ authToken, deployment, sellerId }: FetchLotsBySellerIdParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({ authToken, deployment, path: `<ITEM-API>spa/sellers/${sellerId}/items` });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
